<template lang="pug">
.l-signup-flow__item
  .l-signup-flow__item-circle
    span {{ item.step }}
  | {{ item.title }}
  small.l-signup-flow__item-text--sub(v-if="item.subTitle") {{ item.subTitle }}

</template>

<script>
export default {
  props:{
    item:{
      type: Object
    }
  }
}
</script>
